import { api_get, api_post, api_put, api_delete } from '@lf/api-client/lfApi';
import lfApi from '@lf/api-client/lfApi';

export async function childSignup(username, password, firstName, gradeLevel) {
    try {
        const response = await lfApi.post('/child/signup', {
            username,
            password,
            first_name: firstName,
            grade_level: gradeLevel,
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 409) {
            return { error: 'Username already taken' };
        }
        if (error.response && error.response.data) {
            return error.response.data;
        }
        return { error: 'An error occurred' };
    }
}

export async function submitCoppaAgeCheck(isUnder13, parentEmail = '') {
    return await api_post('/child/coppa-age-check', {
        is_under_13: isUnder13,
        parent_email: parentEmail,
    });
}

export async function getCoppaConsentStatus() {
    return await api_get('/child/coppa-consent');
}

export async function resendCoppaConsentEmail() {
    return await api_post('/child/coppa-consent/resend', {});
}

export async function changeCoppaConsentEmail(parentEmail) {
    return await api_put('/child/coppa-consent/email', { parent_email: parentEmail });
}

export async function getCoppaConsentRequest(token) {
    return await api_get(`/coppa/consent/${token}`);
}

export async function grantCoppaConsent(token, consentChecked) {
    return await api_post(`/coppa/consent/${token}/grant`, { consent_checked: consentChecked });
}

export async function getCoppaChildren() {
    return await api_get('/user/coppa-children');
}

export async function revokeCoppaChild(childProfileId) {
    return await api_post(`/user/coppa-children/${childProfileId}/revoke`, {});
}

export async function deleteCoppaChild(childProfileId) {
    return await api_delete(`/user/coppa-children/${childProfileId}`);
}

export async function getParentLinkStatus() {
    return await api_get('/child/parent-link');
}

export async function createParentLinkRequest(parentEmail) {
    return await api_post('/child/parent-link', { parent_email: parentEmail });
}

export async function cancelParentLinkRequest() {
    return await api_delete('/child/parent-link');
}

export async function getPendingChildLinks() {
    return await api_get('/user/child-links');
}

export async function approveChildLink(token) {
    return await api_post(`/user/child-link/${token}/approve`);
}

export async function rejectChildLink(token) {
    return await api_post(`/user/child-link/${token}/reject`);
}
